import {screeningAction } from 'src/redux/actions/constant';

const {
    RESET_CREATE_SCREENING,
    CREATE_SCREENING_SUCCESS,
    CREATE_SCREENING_FAILURE,
} = screeningAction;

const intitialstate: object = {
  isScreeningCreated: false,
  response: null,
};

export const createScreeningReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case CREATE_SCREENING_SUCCESS: {
      return {
        ...state,
        isScreeningCreated: true,
        response: action.payload,
      };
    }

    case CREATE_SCREENING_FAILURE:
      return {
        ...state,
        isScreeningCreated: false,
        response: action.payload,
      };

    case RESET_CREATE_SCREENING:      
      return intitialstate;

    default:
      return state;
  }
};
